export default __webpack_public_path__ + "static/media/Google_Drive_logo.0a366485.svg";